import Home from 'pages/blog/page';

const MbaBlogPage = () => <Home sportCategory="mlb" />;
export default MbaBlogPage;
